export default {
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: (resolve) => require(['@/views/Home'], resolve)
  },
  {
    path: '/login',
    name: 'Login',
    component: (resolve) => require(['@/views/Login'], resolve),
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/resetpassword/:token?',
    name: 'ResetPassword',
    component: (resolve) => require(['@/views/ResetPassword.vue'], resolve),
    meta: {
      allowAnonymous: true
    }
  },
    /**
     * User endpoints
     */
  {
    path: '/user',
    name: 'User',
    component: (resolve) => require(['@/views/user/UserList'], resolve)
  },
  {
    path: '/user/add',
    name: 'User.Add',
    component: (resolve) => require(['@/views/user/UserUpsert'], resolve)
  },
  {
    path: '/user/edit/:id',
    name: 'User.Edit',
    component: (resolve) => require(['@/views/user/UserUpsert'], resolve)
  },

    /**
     * Location endpoints
     */
  {
    path: '/location',
    name: 'Location',
    component: (resolve) => require(['@/views/location/LocationList'], resolve)
  },
  {
    path: '/location/add',
    name: 'Location.Add',
    component: (resolve) => require(['@/views/location/LocationUpsert'], resolve)
  },
  {
    path: '/location/edit/:id',
    name: 'Location.Edit',
    component: (resolve) => require(['@/views/location/LocationUpsert'], resolve)
  },
  {
    path: '/location/reports',
    name: 'Location.Reports',
    component: (resolve) => require(['@/views/location/LocationReport'], resolve)
  },

    /**
     * Group endpoints
     */
  {
    path: '/group',
    name: 'Group',
    component: (resolve) => require(['@/views/group/GroupList'], resolve)
  },
  {
    path: '/group/add',
    name: 'Group.Add',
    component: (resolve) => require(['@/views/group/GroupUpsert'], resolve)
  },
  {
    path: '/group/edit/:id',
    name: 'Group.Edit',
    component: (resolve) => require(['@/views/group/GroupUpsert'], resolve)
  },
  {
    path: '/group/reports',
    name: 'Group.Reports',
    component: (resolve) => require(['@/views/group/GroupReport'], resolve)
  },

    /**
     * Building endpoints
     */
  {
    path: '/building',
    name: 'Building',
    component: (resolve) => require(['@/views/building/BuildingList'], resolve)
  },
  {
    path: '/building/add',
    name: 'Building.Add',
    component: (resolve) => require(['@/views/building/BuildingUpsert'], resolve)
  },
  {
    path: '/building/edit/:id',
    name: 'Building.Edit',
    component: (resolve) => require(['@/views/building/BuildingUpsert'], resolve)
  },
  {
    path: '/building/reports',
    name: 'Building.Reports',
    component: (resolve) => require(['@/views/building/BuildingReport'], resolve)
  },

    /**
     * Survey endpoints
     */
  {
    path: '/survey',
    name: 'Survey',
    component: (resolve) => require(['@/views/survey/SurveyList'], resolve)
  },
  {
    path: '/survey/add',
    name: 'Survey.Add',
    component: (resolve) => require(['@/views/survey/SurveyAssign'], resolve)
  },
  {
    path: '/survey/edit/:id',
    name: 'Survey.Fulfill',
    component: (resolve) => require(['@/views/survey/SurveyFulfill'], resolve)
  },

    /**
     * Download Survey
     */
  {
    path: '/download/:key?/:userId?',
    name: 'Survey.Download',
    component: (resolve) => require(['@/views/survey/SurveyDownload.vue'], resolve),
    meta: {
      allowAnonymous: true,
      isPublic: true
    }
  },
    /**
     * Forbidden
     */
  {
    path: '/403',
    name: 'Forbidden',
    component: (resolve) => require(['@/views/error-pages/403'], resolve),
    meta: {
      allowAnonymous: true
    }
  },
    /**
     * Not found
     */
  {
    path: '*',
    name: 'NotFound',
    component: (resolve) => require(['@/views/error-pages/404'], resolve),
    meta: {
      allowAnonymous: true
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes.js